import { render, staticRenderFns } from "./ResultSummaryCard.vue?vue&type=template&id=b990be2a&scoped=true&"
import script from "./ResultSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./ResultSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResultSummaryCard.vue?vue&type=style&index=0&id=b990be2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b990be2a",
  null
  
)

export default component.exports